import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 flex-col" }

import { useI18n } from "vue-i18n";
import { HierarchyTagStore } from "shared/types/HierarchyTag";
import { Report } from "@/types/Report";
import { MilestoneReportConfig, MilestoneReportFilters } from "@/types/reports/PlotMilestone";
import ReportFormSection from "@/views/reports/components/ReportFormSection.vue";
import ReportLocationFilterField from "@/views/reports/filters/ReportLocationFilterField.vue";
import MilestoneConfigFields from "@/views/reports/plots/milestone/MilestoneConfigFields.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MilestoneForm',
  props: {
    filters: {},
    config: {},
    aggregation: {},
    hierarchyTags: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ReportFormSection, {
      number: "2",
      label: _unref(t)('analytics.reports.filters')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ReportLocationFilterField, {
            filter: _ctx.filters.location,
            hierarchyTags: _ctx.hierarchyTags,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('change', { filters: { ..._ctx.filters, location: $event } })))
          }, null, 8, ["filter", "hierarchyTags"])
        ])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(ReportFormSection, {
      number: "3",
      label: _unref(t)('analytics.reports.plot_config')
    }, {
      default: _withCtx(() => [
        _createVNode(MilestoneConfigFields, {
          config: _ctx.config,
          filters: _ctx.filters,
          onConfigChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change', { config: $event })))
        }, null, 8, ["config", "filters"])
      ]),
      _: 1
    }, 8, ["label"])
  ], 64))
}
}

})